// extracted by mini-css-extract-plugin
export var barContainer = "_2r-0";
export var extraThin = "_2r-3";
export var fillBar = "_2r-6";
export var fillContainer = "_2r-4";
export var overflow = "_2r-8";
export var overflowContainer = "_2r-5";
export var regular = "_2r-7";
export var thick = "_2r-1";
export var thin = "_2r-2";